import { createContext, useContext } from "react";

/**
 * KAN-1234 — opens the page shell's own replace-file flow from inside the
 * configurator, so a stopped quote offers "upload a different file" without a
 * second upload path next to the shell's button.
 *
 * ``null`` outside ``ConfiguratorPageShell`` (project page, admin builder) and
 * for an operation that takes no file — the caller then offers nothing.
 */
export const ReplaceFileContext = createContext<(() => void) | null>(null);

export function useOpenReplaceFile(): (() => void) | null {
  return useContext(ReplaceFileContext);
}
